module.exports = __webpack_public_path__ + "static/fitbit-settings-android-8ecdbe7445a410f7d0b8c43c5106339b.png";